import { render } from "./TournamentScheduleEditPage.vue?vue&type=template&id=2a43016d"
import script from "./TournamentScheduleEditPage.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__